import { render } from "./WCHeaderTop.vue?vue&type=template&id=558c3a86&scoped=true"
import script from "./WCHeaderTop.vue?vue&type=script&lang=js"
export * from "./WCHeaderTop.vue?vue&type=script&lang=js"

import "./WCHeaderTop.vue?vue&type=style&index=0&id=558c3a86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558c3a86"]])

export default __exports__